import { apiCall } from "service/apiCall";
import { setLoading } from "./general";
import Cookie from "universal-cookie";
import { get } from "lodash";
import * as actionTypes from "redux/constants/dashboard";

const cookie = new Cookie();
const token = cookie.get("login_cookie");

export const getBod2Summary = (projectId) => async (dispatch) => {
  dispatch(setLoading(true));

  let dataReq = {
    url: `/BiofarmaSjtBod2/summary${projectId ? `?projectId=${projectId}` : ""}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    dispatch({ type: actionTypes.GET_BOD2_SUMMARY, payload: res.data });
    dispatch(setLoading(false));
    return res.data;
  } else {
    dispatch(setLoading(false));
    return false;
  }
};

export const getBod2Gap = (projectId) => async (dispatch) => {
  dispatch(setLoading(true));

  let dataReq = {
    url: `/BiofarmaSjtBod2/summary-gap${projectId ? `?projectId=${projectId}` : ""}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    dispatch({ type: actionTypes.GET_BOD2_GAP, payload: res.data });
    dispatch(setLoading(false));
    return res.data;
  } else {
    dispatch(setLoading(false));
    return false;
  }
};

export const getBod3Summary = (projectId) => async (dispatch) => {
  dispatch(setLoading(true));

  let dataReq = {
    url: `/BiofarmaSjtBod3/summary${projectId ? `?projectId=${projectId}` : ""}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    dispatch({ type: actionTypes.GET_BOD3_SUMMARY, payload: res.data });
    dispatch(setLoading(false));
    return res.data;
  } else {
    dispatch(setLoading(false));
    return false;
  }
};

export const getBod3Gap = (projectId) => async (dispatch) => {
  dispatch(setLoading(true));

  let dataReq = {
    url: `/BiofarmaSjtBod3/summary-gap${projectId ? `?projectId=${projectId}` : ""}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };

  let res = await dispatch(apiCall(dataReq));

  if (get(res, "status") === 200) {
    dispatch({ type: actionTypes.GET_BOD3_GAP, payload: res.data });
    dispatch(setLoading(false));
    return res.data;
  } else {
    dispatch(setLoading(false));
    return false;
  }
};
